
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";

/** Common Components */
import FormCreator from "../../../../../../../components/finalForms/FormCreator";
import Buttons from "../../../../../../../components/ui/button/Buttons";

/** Configuration files */
import { addAffiliatesConfig } from "./AddAffiliates.formfield.config";
import { useLazyGetAllClientsQuery } from "../../../../../../../app/services/clientAPI";
import { useLazyGetAllDepartmentsQuery } from "../../../../../../../app/services/departmentAPI";
import { setDropdownOptions } from "../../../../../../../components/finalForms/libs/data/mapDropdownOptions";
import { useAddContractAffiliateMutation, useUpdateContractAffiliateMutation } from "../../../../../../../app/services/contractAPI";
import ToastService from "../../../../../../../services/toastService/ToastService";
import { format_Date } from "../../../../../../../components/finalMolGrid/libs/formatDate";
import { setFieldSetting } from "../../../../../../../utils/formFieldUtils/ManageFields";
import { FieldSettingType } from "../../../../../../../components/finalForms/libs/data/fieldSettingType";
import PropTypes from "prop-types";

const AddAffiliates = ({ isOpen, contractId, rowData, onClose, getList }) => {
  const AddAffiliatesRef = useRef();
  const [affiliateData, setAffiliateData] = useState(addAffiliatesConfig);

  const [getAllClients, {
    isFetching: isAllClientsFetching,
    isSuccess: isAllClientsFetched,
    data: allClientsData,
  },] = useLazyGetAllClientsQuery();

  const [getAllDepartments, {
    isFetching: isAllDepartmentsFetching,
    isSuccess: isAllDepartmentsFetched,
    data: allDepartmentsData
  }] = useLazyGetAllDepartmentsQuery();

  const [addContractAffiliateData, {
    isSuccess: isSuccessAddContractAffiliate,
    data: addAffiliateData
  }] = useAddContractAffiliateMutation();


  const [updateContractAffiliateData, {
    isSuccess: isSuccessUpdateContractAffiliate,
    data: updateAffiliateData
  }] = useUpdateContractAffiliateMutation();

  useEffect(() => {
    getAllClients(0);
    setFieldSetting(affiliateData, 'lClientKey', FieldSettingType.ISFIELDDATALOADING, true);
  }, [isOpen]);

  useEffect(() => {
    if (rowData) {
      const form = { ...addAffiliatesConfig };
      form.initialState = {
        lClientKey: rowData.lClientKey,
        lDepartmentKey: rowData.lDepartmentKey,
        dtEffectiveDate: rowData.startDate ? new Date(rowData.startDate) : null,
        dtEndDate: rowData.endDate ? new Date(rowData.endDate) : null
      }
      setAffiliateData(form);
      const req = {
        plDepartmentKey: rowData.lDepartmentKey,
        plClientKey: rowData.lClientKey,
        pbIncludeInactive: false,
      }
      getAllDepartments(req);
    }
  }, [rowData]);

  useEffect(() => {
    if (!isAllClientsFetching && isAllClientsFetched && allClientsData) {
      setDropdownOptions(allClientsData, 'lClientKey', 'sClientName1', affiliateData, 'lClientKey', setAffiliateData);
      setFieldSetting(affiliateData, 'lClientKey', FieldSettingType.ISFIELDDATALOADING, false);
    }
  }, [isAllClientsFetching, isAllClientsFetched, allClientsData]);

  useEffect(() => {
    if (!isAllDepartmentsFetching && isAllDepartmentsFetched && allDepartmentsData) {
      setDropdownOptions(allDepartmentsData, 'lDepartmentKey', 'sDepartmentName', affiliateData, 'lDepartmentKey', setAffiliateData);
      setFieldSetting(affiliateData, 'lDepartmentKey', FieldSettingType.ISFIELDDATALOADING, false);
    }
  }, [isAllDepartmentsFetching, isAllDepartmentsFetched, allDepartmentsData]);

  useEffect(() => {
    if (isSuccessAddContractAffiliate && addAffiliateData) {
      if (addAffiliateData) {
        ToastService.success(addAffiliateData?.errorMessage);
        getList();
        onClose();
      }
    }
  }, [isSuccessAddContractAffiliate, addAffiliateData]);

  useEffect(() => {
    if (isSuccessUpdateContractAffiliate && updateAffiliateData) {
      if (updateAffiliateData) {
        ToastService.success(updateAffiliateData?.errorMessage);
        getList();
        onClose();
      }
    }
  }, [isSuccessUpdateContractAffiliate, updateAffiliateData]);

  const handleFieldChange = (dataField, updatedFormData) => {
    const plClientKey = updatedFormData.lClientKey;
    const selectedClient =
      plClientKey && typeof plClientKey === "object" ? plClientKey.value : plClientKey;

    if (dataField === "lClientKey") {

      const req = {
        plDepartmentKey: 0,
        plClientKey: selectedClient,
        pbIncludeInactive: false,
      };

      getAllDepartments(req);

      let form = { ...addAffiliatesConfig }
      form.initialState = {
        ...updatedFormData,
        lClientKey: selectedClient,
        lDepartmentKey: null,
      }
      setAffiliateData(form);
    }
  };


  const extractValue = (field) => {
    return field && typeof field === "object" ? field.value : field;
  };

  const handleSave = () => {
    const formData = AddAffiliatesRef.current.getFormData();
    if (!formData) {
      ToastService.error("Please fill all required fields");
      return;
    }
    if (rowData) {
      const updateRequest = {
        plAffiliateKey: rowData.lAffiliateKey,
        plDepartmentKey: extractValue(formData.lDepartmentKey),
        pdtStartDate: format_Date(formData.dtEffectiveDate),
        pdtEndDate: format_Date(formData?.dtEndDate) || null
      }
      updateContractAffiliateData(updateRequest);
    }
    else {
      const request = {
        plContractKey: contractId,
        plDepartmentKey: extractValue(formData.lDepartmentKey),
        pdtStartDate: format_Date(formData.dtEffectiveDate),
        pdtEndDate: format_Date(formData?.dtEndDate) || null
      }
      addContractAffiliateData(request);
    }
  }
  return (
    <div className="row">
      <FormCreator ref={AddAffiliatesRef} config={affiliateData}
        onColumnChange={handleFieldChange}
      />
      <div className="d-flex justify-content-end gap-3 mt-3">
        <Buttons
          buttonText="Save"
          buttonTypeClassName="btn blue-btn"
          titleText="Unassign Selected Items"
          onClick={handleSave}
        />
        <Buttons
          buttonText="Cancel"
          buttonTypeClassName="btn dark-btn"
          titleText="Unassign Selected Items"
          onClick={onClose}
        />
      </div>
    </div>
  );
};

AddAffiliates.propTypes = {
  isOpen: PropTypes.bool,
  contractId: PropTypes.number,
  getList: PropTypes.func,
  onClose: PropTypes.func,
  rowData: PropTypes.shape({
    lClientKey: PropTypes.number,
    lDepartmentKey: PropTypes.number,
    startDate: PropTypes.string,
    endDate: PropTypes.string,
    lAffiliateKey: PropTypes.number,
  }),
  getAllDepartments: PropTypes.func.isRequired,
};


export default AddAffiliates;
